import styled from 'styled-components';
import React from "react";

import Primary from '../Buttons/Primary-Button';
import Secondary from '../Buttons/Secondary-Button';
import LogoSlider from './LogoSlider';

const Left = styled.div`
  width: 50%;
  text-align: left;
  @media only screen and (max-width: 1000px) {
    width: 100%;
  }
`;

const Landing = styled.section`
  display: flex;
  min-height: 70vh;
  @media only screen and (max-width: 1000px) {
    flex-direction: column-reverse;
    height: auto;
  }
`;

const Right = styled.div`
  text-align: center;
  width: 50%;
  @media only screen and (max-width: 1000px) {
    width: 100%;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 2em;
  padding-right: 60px;
  padding-left: 27px;
  @media only screen and (max-width: 1000px) {
    text-align: center;
    padding-left: 13px;
    margin-top: 0px;
  }
`;

const MainText = styled.div`
  margin-top: 20.5vh;
  font-size: 35px;
  color: #223461;
  padding-left: 50px;
  padding-right: 30px;
  font-weight: 600;
  @media only screen and (max-width: 1000px) {
    padding-left: 30px;
    margin-top: 0px;
    font-size: 30px;
    text-align: center;
  }
`;

const Sub = styled.div`
  font-size: 20px;
  padding-left: 50px;
  color: #667988;
  @media only screen and (max-width: 1000px) {
    padding-left: 30px;
    font-size: 18px;
    text-align: center;
  }
`;

const Creative = styled.img`
  padding-right: 50px;
  margin-top: 15vh;
  padding-left: 20px;
  width: 70%;
  @media only screen and (max-width: 1000px) {
    padding-left: 50px;
    margin-top: 100px;
    width: auto;
  }
`;

const BottomSec = styled.section`
  min-height: 30vh;
  padding-right: 50px;
  @media only screen and (max-width: 1000px) {
    padding-right: 0px;
  }
`;

export default function LandingPage() {
  return (
    <>
      <Landing>
        <Left>
          <MainText>The Future of Work is Remote, Rapid & Risk-Free</MainText>
          <Sub style={{ paddingTop: '1em' }}>
            On-Demand Curated Part Time Workforce for all Your Business Needs.
          </Sub>
          <ButtonWrapper>
            <Primary
              style={{ marginTop: '20px' }}
              href="/business"
              className="btn waves-effect waves-light red"
            >
              I want a Curated Workforce
            </Primary>
            <Secondary
              style={{ marginTop: '20px' }}
              href="/freelancer"
              className="btn waves-effect waves-light white"
            >
              I want to Work
            </Secondary>
          </ButtonWrapper>
          {/* <Images>
            <ImageWrapper style={{ marginLeft: '0px' }} src="/business/uber.png" />
            <ImageWrapper src="/business/swiggy.png" />
            <ImageWrapper src="/business/share.png" />
            <ImageWrapper src="/business/hike.png" />
            <ImageWrapper src="/business/mi.png" />
          </Images>

          <Sub style={{ paddingTop: '20px', fontSize: '18px' }}>
            100+ businesses trust GigIndia for getting their work done
          </Sub> */}
        </Left>
        <Right>
          <Creative className="responsive-img" alt="creative" src="/creative.png" />
        </Right>
      </Landing>
      <BottomSec>
        <div style={{ paddingTop: '6vh' }}>
          <LogoSlider />
        </div>
        <Sub style={{ paddingTop: '5vh', fontSize: '18px', textAlign: 'center' }}>
          100+ businesses trust GigIndia for getting their work done
        </Sub>
      </BottomSec>
    </>
  );
}
